import {gql} from '@apollo/client'

export const BULK_UNSUBSCRIBE_CONTACTS = gql`
  mutation BulkUnsubscribeContacts($contactIds: [ID!]!, $reason: String) {
    bulkUnsubscribeContacts(contactIds: $contactIds, reason: $reason) {
      ok
      unsubscribedCount
    }
  }
`

export const BULK_SUBSCRIBE_CONTACTS = gql`
  mutation BulkSubscribeContacts($contactIds: [ID!]!) {
    bulkSubscribeContacts(contactIds: $contactIds) {
      ok
      subscribedCount
    }
  }
`
